import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { WORKING_ORDER } from "constants/action-types";
import { IAction } from "epics/base-epic";
import { IWorkingProducts, products } from "reducers/working-order/products";
import { order, type IWorkingOrderState } from "reducers/working-order/order";
import { company, type IWorkingCompanyState } from "reducers/working-order/companies";
import { availability, type IProductsAvailabilityFetchState } from "reducers/working-order/availability";
import { IFetchStoreState, initialBaseState, progressActions } from "../base-reducers";

export interface IWorkingState {
    order: IWorkingOrderState;
    company: IWorkingCompanyState;
    drafts: IWorkingDraftsState;
    products: IWorkingProducts;
    availability: IProductsAvailabilityFetchState;
}

export interface IWorkingDraftsState extends IFetchStoreState<{ success: boolean }> {
    isValidating: boolean;
    isValid: boolean;
    isSaving: boolean;
    validationError: {
        summary: string;
        messages: Array<{ msg: string; id: string }>;
    };
}

const baseState = {
    ...initialBaseState,
    isValid: null,
    isSaving: false,
    validationError: null,
    isValidating: false,
};

export const working = combineReducers({
    drafts: handleActions<IWorkingDraftsState>(
        {
            ...progressActions(WORKING_ORDER.DRAFTS.SAVE, "isSaving"),
            [WORKING_ORDER.DRAFTS.UPDATE]: (
                state: IWorkingDraftsState,
                { payload }: IAction<IWorkingDraftsState>,
            ): IWorkingDraftsState => ({
                ...state,
                ...payload,
            }),
            [WORKING_ORDER.DRAFTS.VALIDATE]: (state: IWorkingDraftsState): IWorkingDraftsState => ({
                ...state,
                isValidating: true,
                isValid: null,
                validationError: null,
            }),
        } as any,
        baseState,
    ),
    products,
    order,
    company,
    availability,
});
